import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keySearch'
})
export class KeySearchPipe implements PipeTransform {

  transform(items: any[], term: any, param1?: string, param2?: string, param3?: string, param4?: string, param5?: string, param6?: string): any[] {
    if (term === undefined || term === '') return items;
    return items.filter(function (x) {
      if (param6) {
        return (x[param1].toLowerCase().includes(term.toLowerCase()) || x[param2].toLowerCase().includes(term.toLowerCase()) || x[param3].toLowerCase().includes(term.toLowerCase()) || x[param4].toLowerCase().includes(term.toLowerCase()) || x[param5].toLowerCase().includes(term.toLowerCase()) || x[param6].toLowerCase().includes(term.toLowerCase()));
      } else if (param5) {
        return (x[param1].toLowerCase().includes(term.toLowerCase()) || x[param2].toLowerCase().includes(term.toLowerCase()) || x[param3].toLowerCase().includes(term.toLowerCase()) || x[param4].toLowerCase().includes(term.toLowerCase()) || x[param5].toLowerCase().includes(term.toLowerCase()));
      } else if (param4) {
        return (x[param1].toLowerCase().includes(term.toLowerCase()) || x[param2].toLowerCase().includes(term.toLowerCase()) || x[param3].toLowerCase().includes(term.toLowerCase()) || x[param4].toLowerCase().includes(term.toLowerCase()));
      } else if (param3) {
        return (x[param1].toLowerCase().includes(term.toLowerCase()) || x[param2].toLowerCase().includes(term.toLowerCase()) || x[param3].toLowerCase().includes(term.toLowerCase()));
      } else if (param2) {
        return (x[param1].toLowerCase().includes(term.toLowerCase()) || x[param2].toLowerCase().includes(term.toLowerCase()));
      } else if (param1) {
        return (x[param1].toLowerCase().includes(term.toLowerCase()))
      } else {
        return true;
      }
    });

  }
  //   transform(items:any[], columnList:string[]):any {
  //   
  //     if (!items || !columnList) {
  //       return items;
  //     }
  //     // let items=[{"name":'mukund','email':'mukund720'},{"name":'mukund2','email':'2mukund720'}];
  //     // let columnList=['name','email'];
  //     let search="mukund2"
  //     let s='';
  //       for(let d of items)
  //            {
  //            for(let row of columnList)
  //                   {
  //                     if(search==d[row])
  //                     {
  //                   let t=d[row]
  //                   s =s+"</br>"+t;
  //                     }
  //                   }
  //            }

  // }

  // return null;
}





// WEBPACK FOOTER //
// /codebuild/output/src138257614/src/src/app/shared/pipes/key-search.pipe.ts